<template>
  <div id="user-list">
    <v-card>
      <v-card-title> {{ $t("Kyselyt") }} </v-card-title>
      <!-- actions -->

      <!-- <v-card-text>
        <v-alert color="info" text>
          {{ $t("surveyinfo1") }} <router-link :to="{ name: 'admin-survey-list' }">{{ $t("tästä") }}</router-link>
        </v-alert>
      </v-card-text> -->

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn color="primary" class="mb-4" :to="{ name: 'admin-poll-form' }">
            <span>{{ $t("Uusi kysely") }}</span>
          </v-btn>
        </div>

      </v-card-text>
      <v-data-table :headers="tableColumns" :items="polls" :server-items-length="totalCount" :items-per-page="10"
        :options.sync="options" :loading="loading" mobile-breakpoint="0" :footer-props="{
          'items-per-page-options': [10],
        }">
        <!-- title -->
        <template #[`item.title`]="{ item }">
          <div class="d-flex align-center">
            <router-link :to="{ name: 'admin-poll-form', params: { id: item.id } }"
              class="font-weight-medium text-decoration-none">
              {{ item.title }}
            </router-link>
          </div>
        </template>

        <!-- group -->
        <template #[`item.group_name`]="{ item }">
          <v-chip label small color="primary">{{ item.group_name }}</v-chip>
        </template>

        <!-- reply_time -->
        <template #[`item.reply_time`]="{ item }">
          <v-icon v-if="isPollActive(item)" size="18" color="success">{{ icons.mdiCheckCircle }}</v-icon>
          <v-icon v-else size="18" color="error">{{ icons.mdiCloseCircle }}</v-icon>
          {{ getDateTime(item.release_date) }} - {{ getDateTime(item.expire_date) }}
        </template>


        <!-- answers -->
        <template #[`item.answers`]="{ item }">
          <v-badge :content="'' + item.answers">

          </v-badge>

        </template>

        <!-- polls replioes -->
        <template #[`item.view_answers`]="{ item }">
          <router-link :to="{
            name: 'admin-poll-replies',
            params: { pollId: item.id },
          }" class="
              text--primary
              font-weight-semibold
              text-truncate
              cursor-pointer
              text-decoration-none
            ">
            {{ $t("Näytä vastaukset") }} &raquo;
          </router-link>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>


<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import adminApi from "@/api/admin";
import { mdiCheckboxMarkedCircle, mdiCloseCircle, mdiPlus, mdiCheckCircle } from "@mdi/js";
import { useTranslations } from "@core/libs/i18n";
import { getDateTime } from "@/@core/utils/datetime_helpers";
import moment from "moment";

export default {
  setup() {
    const polls = ref([]);
    const totalCount = ref(0);

    const page = ref(1);
    const options = ref({});
    const loading = ref(false);

    const { t } = useTranslations();

    const tableColumns = [
      { text: t("Otsikko").toUpperCase(), value: "title", sortable: false },
      { text: t("Ryhmä").toUpperCase(), value: "group_name", sortable: false },
      { text: t("Vastausaika").toUpperCase(), value: "reply_time", sortable: false },
      { text: t("Vastauksia").toUpperCase(), value: "answers", sortable: false, align: 'center' },
      {
        text: "",
        value: "view_answers",
        sortable: false,
      },
    ];
    // fetch data
    const fetchPolls = async () => {
      loading.value = true;
      const response = await adminApi.getPolls(page.value);

      polls.value = response.data.results;
      totalCount.value = response.data.count;

      loading.value = false;
    };

    const isPollActive = (poll) => {
      return moment(new Date()).isBetween(poll.release_date, poll.expire_date);
    }

    watch(options, () => {
      page.value = options.value.page;
      fetchPolls();
    });

    // UnRegister on leave
    onMounted(() => {
      // fetchPolls();
    });

    return {
      polls,
      totalCount,
      tableColumns,
      options,
      loading,
      getDateTime,
      isPollActive,
      icons: {
        mdiCheckboxMarkedCircle,
        mdiCloseCircle,
        mdiPlus,
        mdiCheckCircle,
      },
      t,
    };
  },
};
</script>

<style></style>
